import { createSelector } from 'reselect';
import getCurrentPaging from '@src/containers/Session/selectors/getCurrentPaging';

const metaInfo = (store) => store.SpacesListing.loadSpaces.data?.meta || {};

const getSpacesPager = createSelector(
	getCurrentPaging,
	metaInfo,
	(pager, meta) => {
		return {
			...pager,
			totalPages: meta.totalPages || 1,
			totalCount: meta.totalCount,
		};
	},
);

export default getSpacesPager;
